var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame148(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 44C35.3248 44 45 34.6466 45 23C45 11.3534 35.3248 2 23.5 2C11.6752 2 2 11.3534 2 23C2 34.6466 11.6752 44 23.5 44Z",
    fill: "#82D8C0",
    stroke: "#82D8C0",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3735 24.1294C26.9055 24.1294 29.7711 21.4129 29.7711 18.0647C29.7711 14.7165 26.9055 12 23.3735 12C19.8415 12 16.9759 14.7165 16.9759 18.0647C16.9759 21.4129 19.8415 24.1294 23.3735 24.1294ZM29.0602 25.4771H26.6123C25.626 25.9067 24.5286 26.151 23.3735 26.151C22.2184 26.151 21.1255 25.9067 20.1347 25.4771H17.6867C14.5457 25.4771 12 27.8904 12 30.868V31.5419C12 32.6579 12.9552 33.5634 14.1325 33.5634H32.6145C33.7918 33.5634 34.747 32.6579 34.747 31.5419V30.868C34.747 27.8904 32.2013 25.4771 29.0602 25.4771Z",
    fill: "#2D607B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame148);
export default __webpack_public_path__ + "static/media/Frame 148.8b786b1b8cac1bf04e56e0f8f75b33f8.svg";
export { ForwardRef as ReactComponent };